var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 114,
    viewBox: "0 0 208 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.671875 0.144531H17.1299C18.8224 0.150392 20.4956 0.506556 22.045 1.1908C23.5944 1.87504 24.9867 2.87267 26.1352 4.12145L85.9569 69.3689L93.3578 61.2991L53.3584 17.6445H69.9199C71.6088 17.6493 73.2785 18.0051 74.8238 18.6895C76.3692 19.3739 77.7568 20.3722 78.8994 21.6214L104.323 49.3429L129.747 21.6214C130.893 20.3702 132.285 19.3709 133.835 18.6865C135.385 18.002 137.059 17.6473 138.752 17.6445H155.21L115.266 61.2746L122.704 69.3854L182.563 4.12148C183.706 2.87219 185.093 1.87392 186.639 1.1895C188.184 0.505076 189.854 0.149313 191.543 0.144562H208.001L173.611 37.6572V65.2636C173.607 69.814 172.659 74.3137 170.828 78.4757C168.997 82.6378 166.322 86.3709 162.975 89.437C156.479 95.1957 147.986 98.152 139.335 97.6655C130.685 97.179 122.573 93.2888 116.758 86.8377L104.305 73.2467L91.8621 86.8377C87.4872 91.8236 81.7026 95.3508 75.2802 96.9487C68.8578 98.5466 62.103 98.1392 55.9171 95.7809C49.7312 93.4226 44.4084 89.2255 40.6588 83.7496C36.9093 78.2738 34.9115 71.7796 34.9318 65.1336V37.5142L0.671875 0.144531ZM157.567 55.158L134.638 80.168C136.572 80.9972 138.643 81.4611 140.746 81.5351C142.877 81.621 145.003 81.2815 147.002 80.5364C149 79.7913 150.832 78.6554 152.391 77.1943C153.973 75.7118 155.245 73.9279 156.134 71.9465C157.022 69.9651 157.509 67.8259 157.567 65.6535V55.158ZM50.9758 55.0145L74.0279 80.1592C72.0885 80.9939 70.0107 81.4608 67.8996 81.5351C65.7521 81.6349 63.6065 81.3023 61.5889 80.5569C59.5713 79.8114 57.7224 78.6681 56.1512 77.1943C54.5693 75.7118 53.2971 73.9279 52.4085 71.9465C51.52 69.9651 51.0329 67.8259 50.9758 65.6535V55.0145ZM104.337 89.4648L93.4424 101.344L104.337 113.248L115.257 101.344L104.337 89.4648Z",
    fill: "url(#paint0_linear_5239_35282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5239_35282",
    x1: 163.181,
    y1: 111.368,
    x2: 163.181,
    y2: 12.1533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.4f2fc5f0ac434f3f15aa986641478f04.svg";
export { ForwardRef as ReactComponent };